import React, { useState, useEffect } from 'react';
import { Fab, Zoom, useScrollTrigger } from '@mui/material';
import { styled } from '@mui/material/styles';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

// Styled Components
const StyledScrollToTopFab = styled(Fab)(({ theme }) => ({
  position: 'fixed',
  bottom: 16,
  right: 16,
  zIndex: 1000,
}));

export const ScrollToTopButton: React.FC = () => {
  const [showButton, setShowButton] = useState(false);
  
  // Show button when scrolled down 300px
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 300,
  });

  useEffect(() => {
    setShowButton(trigger);
  }, [trigger]);

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <Zoom in={showButton}>
      <StyledScrollToTopFab
        color="primary"
        size="medium"
        onClick={handleClick}
        aria-label="Scroll naar boven"
      >
        <KeyboardArrowUpIcon />
      </StyledScrollToTopFab>
    </Zoom>
  );
}; 